import {AbstractEvent} from "@/modules/base/events";
import {StaffMember} from "@/modules/staff/entity";

export class BeforeSackStaffMemberEvent extends AbstractEvent {
  constructor(
    public staffMember: StaffMember,
    public price: number,
  ) {
    super();
  }
}